<template>
    <dialog-window
        :show="show"
        v-bind="$store.getters['dialog/dialogProps']"
        :closeOnEscape="true"
        icon="far fa-pencil-ruler"
        :color="variables.colorMain"
        @closed="onCancel"
        style="z-index: 1007;"
    >
        <template v-if="header" v-slot:header>{{ header }}</template>
        <template v-slot:body>
            <div class="info-label" v-if="body" v-html="body"></div>
            <input class="full-width" v-model="value" ref="input" />
        </template>
        <template v-slot:footer>
            <button @click="onCancel">{{ cancelText }}</button>
            <button class="button primary" ref="ok" @click="onOk">{{ okText }}</button>
        </template>
    </dialog-window>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { constants } from '../../utils';

    export default {
        name: 'DialogPrompt',
        data() {
            return {
                value: ''
            };
        },
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                header: 'dialog/header',
                body: 'dialog/body',
                okText: 'dialog/okText',
                text: 'dialog/text',
                cancelText: 'dialog/cancelText',
                variables: 'layout/variables'
            })
        },
        methods: {
            onCancel() {
                this.$store.getters['dialog/cancel']();
                this.$store.dispatch('dialog/clear');
            },
            onOk() {
                this.$store.getters['dialog/ok'](this.value);
                this.$store.dispatch('dialog/clear');
            },
            submitIfEnter(e) {
                if (e.which === constants.KEY_ENTER) this.$refs.ok.click();
            }
        },
        watch: {
            async show(show) {
                if (show) {
                    this.value = this.text;
                    document.addEventListener('keypress', this.submitIfEnter);
                    await this.$nextTick();
                    this.$refs.input.select();
                } else {
                    document.removeEventListener('keypress', this.submitIfEnter);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .info-label {
        margin-bottom: 0.35rem;
    }
</style>